import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import { list } from '../../cruds/restApi';
import debounce from 'lodash.debounce';
import './InputTextAutocomplete.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import { classNames } from '../../functions/classNames';

const LIMIT = 10;

class InputTextAutocomplete extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      suggestions: [],
    };
    this.debounced = debounce(this.loadSuggestions, 300);
  }

  loadSuggestions = (value) => {
    list(this.props.from, { text: value, limit: LIMIT })
      .then(data => this.setState({
              suggestions: data.values,
              count: data.count,
            }));
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.debounced(value);
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  handleChange = (event, { newValue, method }) => {
    if (method === 'type') {
      this.props.handleChange(event);
    }

    if (method === 'click') {
      this.props.handleChange({
        target: {
          name: this.props.name,
          value: newValue,
        },
      });
    }
  };

  shouldRenderSuggestions = (value) => {
    return value.trim().length > 0;
  };

  renderSuggestionsContainer = ({ containerProps, children, query }) => {
    return (
      <div {...containerProps}>
        {children}
        {this.state.count > LIMIT ?
          <div className="additional-results-count">{
            getLabel(this.context.locale, 'general.andOther') + ' ' +
            (this.state.count - LIMIT) + ' ' +
            getLabel(this.context.locale, 'general.results')
          }</div> : ''
        }
      </div>
    );
  };

  renderSuggestion = (suggestion) => (
    <div className="suggestion-row">{suggestion}</div>
  );

  render() {
    const inputProps = {
      value:  this.props.value,/*this.props.name =="dpiUsage" ? this.props.value.dpiUsage == null ? "" : this.props.value.dpiUsage : this.props.value,*/
      name: this.props.name,
      onChange: this.handleChange,
    };

    return (
      <div className={classNames('InputTextAutocomplete', this.props.error ? 'hasError' : '')}
            style={this.props.style}
      >
        <div className="inputLabel">
          {getLabel(this.context.locale, this.props.label)}
          {this.props.required ? <span className="required">*</span> : ''}
        </div>
        <Autosuggest
          suggestions={this.state.suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={suggestion => suggestion}
          renderSuggestion={this.renderSuggestion}
          renderSuggestionsContainer={this.renderSuggestionsContainer}
          shouldRenderSuggestions={this.shouldRenderSuggestions}
          inputProps={ inputProps }
        />
      </div>
    );
  }

}

InputTextAutocomplete.contextTypes = {
  locale: PropTypes.string,
};

export default InputTextAutocomplete;



// WEBPACK FOOTER //
// ./src/main/components/input/InputTextAutocomplete.js